(() => {
  const initPolicyPage = () => {
    const page = document.querySelector('.lufasnd-policy-page');
    const container = page?.querySelector('.shopify-policy__container');
    const body = container?.querySelector('.shopify-policy__body');

    if (!page || !container || !body || body.dataset.policyUiReady === 'true') return;

    const headings = Array.from(body.querySelectorAll('h2')).filter((heading) => heading.textContent.trim());
    if (!headings.length) return;

    body.dataset.policyUiReady = 'true';

    const layout = document.createElement('div');
    layout.className = 'lufasnd-policy-layout';

    const nav = document.createElement('nav');
    nav.className = 'lufasnd-policy-toc';
    nav.setAttribute('aria-label', 'Policy sections');

    const navTitle = document.createElement('p');
    navTitle.className = 'lufasnd-policy-toc__title';
    navTitle.textContent = 'On this page';

    const list = document.createElement('ol');
    const links = [];

    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `policy-section-${index + 1}`;

      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();

      link.addEventListener('click', (event) => {
        event.preventDefault();
        heading.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
        history.replaceState(null, '', `#${heading.id}`);
      });

      links.push(link);
      item.appendChild(link);
      list.appendChild(item);
    });

    nav.append(navTitle, list);
    body.before(layout);
    layout.append(nav, body);

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];

          if (!visible) return;

          links.forEach((link) => {
            link.classList.toggle('is-active', link.hash === `#${visible.target.id}`);
          });
        },
        { rootMargin: '-15% 0px -70% 0px', threshold: 0 }
      );

      headings.forEach((heading) => observer.observe(heading));
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPolicyPage, { once: true });
  } else {
    initPolicyPage();
  }

  document.addEventListener('shopify:section:load', initPolicyPage);
})();
